<template>
  <div class="modal__finish-game">
    <h3>{{$t('modal.finishGame.legend_1')}}<br>
      {{$t('modal.finishGame.legend_2')}}</h3>
    <button class="modal__finish-game__action" @click.prevent="exitGame">{{$t('modal.finishGame.action')}}</button>
  </div>
</template>
<script>
import persistentData from '@/plugins/persistentData'

export default {
  methods: {
    exitGame() {
      this.$store.dispatch('closeModal')
      const dataGame = persistentData.getData(`game-${this.$route.params.id}`, true)
      
      if ( dataGame ) {
        this.$store.dispatch('gameLeave', {
          gameId: dataGame.gameId,
          teamId: dataGame.teamId
        })
        this.$store.dispatch('destroyGameStat')
        this.$store.dispatch('destroyUserIsInGame')
        persistentData.removeData(`game-${this.$route.params.id}`)
        this.$router.push('/home/games')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.modal__finish-game {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 400px;
  background: $white;
  height: 208px;
  width: 100%;
  border-radius: $redondeadobig;
  margin: 0 $margin-kilo;
  position: relative;

  @media (min-width: 372px) {
    align-items: flex-start;
  }

  h3 {
    padding: 0 $margin-kilo;
    // max-width: 240px;
    width: 100%;
    text-align: center;
    margin-top: -50px;

    // @media (min-width: 372px) {
    //   text-align: left;
    // }
  }

  &__action {
    width: 100%;
    background: $lightblue;
    color: $white;
    padding: $margin-base;
    margin-top: $margin-mega;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 0 0 $redondeadobig $redondeadobig;
    z-index: 2;
    border-top: 1px solid $white;
    position: absolute;
    bottom: -8px;
  }
}
</style>